@if (product) {
    <div class="product-tag-wrapper">
        @if (product.novelty) {
            <div class="bg-summer-light product-tag">
                {{ 'productItem.novelty' | cxTranslate }}
            </div>
        }
        @if (product.campaign) {
            <div class="bg-yellow product-tag">
                {{ 'productItem.campaign' | cxTranslate }}
            </div>
        }
        @if (product.sponsored) {
            <div class="bg-autumn-light product-tag">
                {{ 'productItem.sponsored' | cxTranslate }}
            </div>
        }
        @if (product.seasonal) {
            <div class="bg-purple-light product-tag">
                {{ 'productItem.seasonal' | cxTranslate }}
            </div>
        }
    </div>
}
